import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ENVIRONMENT_CONFIG, EnvironmentConfig } from '@ipreo/northstar';
import { UserBranchDetailsApiDto } from '../state/global/user-details-api/models/user-branch-details-api-dto';
import { BidcompApiConfig } from './userdetails-api.config';
import { UserDetailsApiDto } from '../state/global/user-details-api/models/user-details-api-dto';

@Injectable()
export class BidcompGlobalApiUserService {
  private readonly env: string;
  private rootUrl: string;

  constructor(
    private readonly http: HttpClient,
    @Inject(ENVIRONMENT_CONFIG) config: EnvironmentConfig
  ) {
    this.env = config.params.env as string;
    this.setRootURL();
  }

  public setRootURL(): void {
    const env = this.getClientEnv();
    this.rootUrl = BidcompApiConfig[env] || BidcompApiConfig['qx'];
  }

  private getClientEnv(): string {
    const clientEnv = window.sessionStorage.getItem('client_env');
    return clientEnv ? clientEnv : this.env;
  }

  public getCurrentUser(): Observable<UserDetailsApiDto> {
    const url = `${this.rootUrl}/api/v1/current-user`;
    return this.http.get<UserDetailsApiDto>(url);
  }

  public getSiblingBranches(): Observable<UserBranchDetailsApiDto[]> {
    const url = `${this.rootUrl}/api/v1/current-user/sibling-branches`;
    return this.http.get<UserBranchDetailsApiDto[]>(url);
  }
}
